var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekButton, PeekFormControl, PeekFormLabel, PeekImageSelector, PeekStack, } from "@piiqtechnologies/ui-components";
import { SIGNED_URL_UPLOAD_TYPE, uploadFileToPreSignedURL, useError, useLoader, useSignedURL, } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { FloorplanEditorDialog } from "../floorplan-editor";
import messages from "./messages.i18n";
const isSvgFile = (fileName) => {
    return (fileName === null || fileName === void 0 ? void 0 : fileName.toLowerCase().endsWith(".svg")) || false;
};
export const S3ImageUploader = (_a) => {
    var { imageUrl, label, onChange, onChangeLazyS3Upload, lazyS3Upload, imageKey, bucket, enableEditor = false, onEditorSave, editorImageUrl } = _a, props = __rest(_a, ["imageUrl", "label", "onChange", "onChangeLazyS3Upload", "lazyS3Upload", "imageKey", "bucket", "enableEditor", "onEditorSave", "editorImageUrl"]);
    const intl = useIntl();
    const [image, setImage] = useState(null);
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const { setLoader } = useLoader();
    const { setError } = useError();
    const [getImageUploadURL] = useSignedURL();
    const onImageChange = (image) => __awaiter(void 0, void 0, void 0, function* () {
        setImage(image);
        if (!lazyS3Upload) {
            try {
                setLoader(true);
                if (image) {
                    const fileName = `${imageKey}/${image.file.name}`;
                    const uploadURL = yield getImageUploadURL({
                        uploadType: bucket,
                        fileName,
                    });
                    yield uploadFileToPreSignedURL(uploadURL, image.file);
                    onChange(fileName);
                    return;
                }
                onChange("");
            }
            catch (ex) {
                setError((ex === null || ex === void 0 ? void 0 : ex.message) || "Error uploading image to s3");
                console.log("Error uploading image to s3", ex);
            }
            finally {
                setLoader(false);
            }
        }
        else {
            onChangeLazyS3Upload(image);
        }
    });
    useEffect(() => {
        if (enableEditor && editorImageUrl) {
            setImage({ dataURL: editorImageUrl });
            return;
        }
        if (imageUrl) {
            if (enableEditor && isSvgFile(imageUrl)) {
                fetch(imageUrl)
                    .then((response) => {
                    if (!response.ok)
                        throw new Error("Failed to fetch");
                    return response.text();
                })
                    .then((svgText) => {
                    setImage({
                        dataURL: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgText)}`,
                    });
                })
                    .catch(() => setImage({ dataURL: imageUrl }));
            }
            else {
                setImage({ dataURL: imageUrl });
            }
        }
        else {
            setImage(null);
        }
    }, [imageUrl, enableEditor, editorImageUrl, bucket]);
    const acceptTypes = bucket === SIGNED_URL_UPLOAD_TYPE.FLOORPLAN ? ["jpg", "jpeg", "png", "svg"] : ["jpg", "jpeg", "png"];
    const isCurrentImageSvg = (imageUrl && isSvgFile(imageUrl)) ||
        (editorImageUrl && editorImageUrl.startsWith("data:image/svg+xml")) ||
        ((image === null || image === void 0 ? void 0 : image.file) && isSvgFile(image.file.name));
    const showEditButton = enableEditor && isCurrentImageSvg;
    const finalEditorImageUrl = editorImageUrl || (image === null || image === void 0 ? void 0 : image.dataURL) || imageUrl;
    return (React.createElement(PeekFormControl, { fullWidth: true },
        label && React.createElement(PeekFormLabel, { size: "small" }, label),
        React.createElement(PeekStack, { spacing: 1 },
            React.createElement(PeekImageSelector, Object.assign({ height: 215, acceptType: acceptTypes, maxFileSize: 3000000, value: ((image === null || image === void 0 ? void 0 : image.dataURL) && image) || null, onChange: onImageChange, uploadTitle: intl.formatMessage(messages.imageUploaderUploadTitle), updateTitle: intl.formatMessage(messages.imageUploaderUpdateTitle), description: intl.formatMessage(messages.imageUploaderUploadDescription), maxFileSizeErrorMessage: intl.formatMessage(messages.imageUploaderUploadMaxFileSizeError), acceptTypeErrorMessage: intl.formatMessage(messages.imageUploaderUploadAccestTypeError) }, props)),
            showEditButton && (React.createElement(PeekButton, { variant: "outlined", onClick: () => setIsEditorOpen(true), fullWidth: true }, intl.formatMessage(messages.editFloorplanButton)))),
        enableEditor && isCurrentImageSvg && finalEditorImageUrl && onEditorSave && (React.createElement(FloorplanEditorDialog, { open: isEditorOpen, imageUrl: finalEditorImageUrl, onClose: () => setIsEditorOpen(false), onSave: onEditorSave }))));
};
export default S3ImageUploader;
